import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useGuidedHighlightingGetAnswers = () => {
  const createEventRecordRequest = useCallback(
    (params: { articleId: string }) => {
      const articleId = params.articleId;
      const requestUrl = `${API_BASE_URL}/api/v3/annotations/?content_id=${articleId}`;
      const requestConfig = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };
      return new Request(requestUrl, requestConfig);
    },
    [],
  );
  return useRestMutation(createEventRecordRequest);
};

export default useGuidedHighlightingGetAnswers;
